// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import Croppa from 'vue-croppa'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-croppa/dist/vue-croppa.css'
import './assets/css/base.css'
import axios from './httpjs.js'
import axio from 'axios'
import store from './store/index.js'
import view from './view'
import formatDate from './components/common/date.js'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (to.path == '/') {
    if (!axios.defaults.headers.post['tokenId']) {
      next('/login')
    } else {
      next();
    }
  }else {
    next();
  }

})
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Croppa);


Vue.filter('formatDate', formatDate)

for (let i in view) {
  Vue.component(i, view[i])
}
Vue.prototype.$http = axios;
Vue.prototype.$https = axio;
/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  mounted() {}
});



// WEBPACK FOOTER //
// ./src/main.js